import { kea } from 'kea'
import { filter, get, map, find, compact } from 'lodash'
import PropTypes from "prop-types";
import { put, all, call } from 'redux-saga/effects'

import { ShopPaymentMethods, Carts } from '@gratify-eu/entities'

import entities from '~/entities'
import {calculateCartTotal} from "~/utils/money";

import rootLogic from '~/scenes/logic'

export default kea({
  path: () => ['scenes', 'payment'],

  connect: {
    actions: [
      rootLogic, [
        'next'
      ]
    ],
    values: [
      entities, [
        'shopPaymentMethods',
      ],
      rootLogic, [
        'loading as cartLoading'
      ],
    ],
  },

  actions: () => ({
    setMethodData: (id, data) => ({id, data}),
    selectPaymentMethod: (paymentMethod, extra) => ({paymentMethod, extra}),
    setLoading: true,
    clearLoading: true,
  }),

  reducers: ({ actions, constants }) => ({
    paymentMethodData: [{}, PropTypes.object, {
      [actions.setMethodData]: (_, payload) => {
        const { id, data } = payload || {};

        if(id) {
          return {..._, [id]: data};
        }

        return _;
      },
    }],
    loading: [false, PropTypes.bool, {
      [actions.setLoading]: () => (true),
      [actions.clearLoading]: () => (false),
    }],
  }),

  selectors: ({ constants, selectors }) => ({
    currentPaymentMethod: [
      () => [
        entities.selectors.activeCart,
        entities.selectors.shopPaymentMethods
      ], (activeCart, shopPaymentMethods) => {
        if(activeCart && activeCart.payment_method) {
          const paymentMethod = shopPaymentMethods[activeCart.payment_method];

          if(paymentMethod) {
            return paymentMethod
          }
        }

        return null;
      },
      PropTypes.object
    ],
    paymentMethodArguments: [
      () => [
        entities.selectors.activeCart,
      ], (activeCart) => {
        if(activeCart && activeCart.payment_method_arguments) {
          return activeCart.payment_method_arguments
        }
      },
      PropTypes.object
    ],
    showProvider: [
      () => [
        entities.selectors.shopPaymentMethods
      ], (shopPaymentMethods) => {
        const paysera = find(shopPaymentMethods, {type: 'ShopPayseraMethod'});
        const makecommerce = find(shopPaymentMethods, {type: 'ShopMaksekeskusMethod'});
        const gratify = find(shopPaymentMethods, {type: 'ShopGratifyMethod'});

        return compact([paysera, makecommerce, gratify]).length > 1;
      },
      PropTypes.bool
    ],
  }),

  takeLatest: ({actions, workers}) => ({
    [actions.selectPaymentMethod]: workers.selectPaymentMethod
  }),
  start: function * () {
    const { setLoading, clearLoading } = this.actionCreators;
    const shopPaymentMethods = yield this.get('shopPaymentMethods');

    const initializableMethods = filter(shopPaymentMethods, (method) => {
      return !!get(method, 'actions.initialize');
    });

    if(initializableMethods.length > 0) {
      yield put(setLoading());
      yield all(map(initializableMethods, (method) => {
        return call(this.workers.initPaymentMethod, method);
      }));
      yield put(clearLoading());
    }

  },
  workers: {
    * initPaymentMethod (paymentMethod) {
      const { setMethodData } = this.actionCreators;
      if(paymentMethod && paymentMethod.id) {
        try {
          const activeCart = yield entities.get('activeCart');
          const total = calculateCartTotal(activeCart)
          const initAction = get(paymentMethod, 'actions.initialize', null);

          if(total && initAction) {
            const data = yield call(
              ShopPaymentMethods.workers.applyPaymentMethodAction,
              ShopPaymentMethods.actions.paymentMethodAction.request(initAction, {amount: total.amount}),
              true
            );

            yield put(setMethodData(paymentMethod.id, data))
          }
        } catch(e) {
          // TODO: handle init failed methods
        }
      }
    },

    * selectPaymentMethod (action) {
      const { setLoading, clearLoading } = this.actionCreators;
      const { paymentMethod, extra } = action.payload || {};
      const activeCart = yield entities.get('activeCart');

      if(paymentMethod && paymentMethod.url && activeCart) {
        try {
          yield put(setLoading());
          yield call(Carts.workers.update, Carts.actions.update.request(activeCart.id, {
            payment_method: paymentMethod.url,
            payment_method_arguments: extra || null,
          }));
          yield put(clearLoading());
        } catch(e) {
          yield put(clearLoading());
          console.error(e);
        }
      }
    }
  }
})
